var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"UserCenter"},[_c('div',{staticClass:"inner_center"},[_c('div',{staticClass:"menu"},[_c('UserCenterMenu',{attrs:{"record-menu":_vm.menu}})],1),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }